import { render, staticRenderFns } from "./RemissionCard.vue?vue&type=template&id=e70361c8&scoped=true"
import script from "./RemissionCard.vue?vue&type=script&lang=js"
export * from "./RemissionCard.vue?vue&type=script&lang=js"
import style0 from "./RemissionCard.vue?vue&type=style&index=0&id=e70361c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70361c8",
  null
  
)

export default component.exports